import {EnrichedDavContact} from "../services/messages/VCardContactData";

export const SHOW_CONTACT = "SHOW_CONTACT";

export interface ShowContactAction {
    type: typeof SHOW_CONTACT;
    contact?: EnrichedDavContact;
}

export type ContactActionTypes =
    ShowContactAction
    ;
